export const TidalCard = ({ url, meta, postId }) => {
  // Extract Tidal content for embed
  // https://tidal.com/browse/track/123 -> embed
  const match = url.match(/tidal\.com\/(?:browse\/)?(track|album|playlist)\/(\d+)/);

  if (match) {
    const [, type, id] = match;
    const typeMap = { track: "tracks", album: "albums", playlist: "playlists" };
    return (
      <div className="mt-3 rounded-2xl overflow-hidden w-full max-w-full" data-testid={`tidal-card-${postId}`}>
        <iframe
          src={`https://embed.tidal.com/${typeMap[type] || "tracks"}/${id}?layout=gridify&disableAnalytics=true`}
          width="100%"
          height="150"
          frameBorder="0"
          allow="encrypted-media"
          loading="lazy"
          className="rounded-2xl"
          title="Tidal"
          style={{ maxWidth: "100%" }}
        />
      </div>
    );
  }

  // Iframe embed from meta
  if (meta && meta.embed_src) {
    return (
      <div className="mt-3 rounded-2xl overflow-hidden w-full max-w-full" data-testid={`tidal-card-${postId}`}>
        <iframe src={meta.embed_src} width="100%" height="120" frameBorder="0" allow="encrypted-media" title="Tidal" className="rounded-2xl" style={{ maxWidth: "100%" }} />
      </div>
    );
  }

  // Fallback card without external link
  return (
    <div className="mt-3 flex items-center gap-3 bg-[#000]/5 border border-[#000]/20 rounded-2xl p-3 w-full max-w-full" data-testid={`tidal-card-${postId}`}>
      <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-xl bg-black flex items-center justify-center shrink-0">
        <span className="text-white font-bold text-base sm:text-lg">T</span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-foreground truncate">{meta?.title || "Tidal"}</p>
        <p className="text-xs text-muted-foreground mt-0.5">Tidal</p>
      </div>
    </div>
  );
};
